import { Form } from "@shared/antd/form";
import { Card } from "@shared/antd/card";
import { Spin } from "@shared/antd/spin";
import React, { useCallback, useMemo } from "react";
import { WrappedFormUtils } from "antd/lib/form/Form";
import ExtTaskDataCards from "../../../pages/Bproc/TaskData/ExtTaskDataCards";
import { OutcomeButtons } from "app/features/bpm-controller/outcome-buttons";
import { useApplicationForm } from "../lib/use-application-form";
import { StartButton } from "app/features/bpm-controller/ui/start-button";
import { useApplicationStore } from "app/entities/form-controller/abstract";

interface ChildrenProps {
  submit: () => void;
  reset: () => void;
  isLoadingProcess?: boolean;
}

type FormWrapperProps = {
  form: WrappedFormUtils<any>;
  children: (actions: ChildrenProps) => React.ReactNode;
  actionsButtons?: React.ReactNode[] | JSX.Element[];
  onSubmit?: (values: Record<string, any>) => void;
  onStatusChange?: (status: string) => void;
  beforeSubmit?: (values: Record<string, any>) => Record<string, any>;
  isLoading?: boolean;
  isNeedFile?: boolean;
};

const FormWrapperComponent: React.FC<FormWrapperProps> = React.memo(
  ({
    form,
    children,
    onSubmit,
    beforeSubmit,
    actionsButtons,
    isLoading,
    isNeedFile,
  }) => {
    const {
      bpmFormData,
      validateFields,
      setApplicationKey,
      isLoading: isLoadingForm,
    } = useApplicationForm(form);
    const store = useApplicationStore();
    const isValidate = store((s) => s.isValidate);

    const { isEnd, isNotDraft } = store((s) => s.getStatusRequest());

    const handleSubmit = useCallback(
      (e?: React.FormEvent) => {
        if (e) e.preventDefault();
        validateFields((err: any, values: any) => {
          if (!err) {
            const processedValues = beforeSubmit
              ? beforeSubmit(values)
              : values;
            onSubmit(processedValues);
            if (processedValues.applicationKey) {
              setApplicationKey(processedValues.applicationKey);
            }
          }
        });
      },
      [validateFields, beforeSubmit, onSubmit, setApplicationKey],
    );

    const handleReset = useCallback(() => {
      console.log("reset");
    }, []);

    const task = useMemo(
      () => bpmFormData?.tasks && Array.from(bpmFormData.tasks),
      [bpmFormData?.tasks],
    );

    const buttonBPM = useMemo(() => {
      if (!bpmFormData?.formData?.outcomes) return [];

      return bpmFormData.formData.outcomes
        .filter((o) => bpmFormData.isUserInitiator || o.id !== "CANCEL")
        .sort((a1, a2) => a2.id.localeCompare(a1.id))
        .map((o) => <OutcomeButtons key={o.id} outcome={o} form={form} />);
    }, [bpmFormData?.formData?.outcomes, bpmFormData?.isUserInitiator]);

    const actions = useMemo(() => {
      if (isNeedFile) return [...actionsButtons];

      return [...(actionsButtons || []), ...(buttonBPM || [])].filter(Boolean);
    }, [actionsButtons, buttonBPM, isNeedFile]);

    const childrenProps = useMemo(
      () => ({
        submit: () => handleSubmit(),
        reset: handleReset,
        isLoadingProcess: isLoading || isLoadingForm,
      }),
      [handleSubmit, handleReset],
    );
    const resultButtons = () => {
      if (isEnd()) {
        return [actions[0]];
      }
      //TODO Убрать костыль isNeedFile

      if (bpmFormData.isStartForm && !isNotDraft()) {
        return [...actions, <StartButton form={form} key={"startForm"} />];
      }

      // if (!bpmFormData?.formData?.outcomes) {
      //   return [""];
      // }
      return actions;
    };

    return (
      <Spin spinning={isLoading || isLoadingForm || isValidate} size="large">
        <Card
          className="narrow-layout card-actions-container"
          actions={resultButtons()}
          bordered={false}
        >
          <Form onSubmit={handleSubmit} form={form}>
            {children(childrenProps)}
            {task && <ExtTaskDataCards isDep={true} tasks={task} />}
          </Form>
        </Card>
      </Spin>
    );
  },
);

FormWrapperComponent.displayName = "FormWrapperComponent";

export const FormWrapper = FormWrapperComponent;
